<template>
  <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
    <notifications></notifications>

    <side-bar
      :sidebar-item-color="sidebarBackground"
      :sidebar-background-image="sidebarBackgroundImage"
    >
      <mobile-menu slot="content"></mobile-menu>
      <sidebar-link to="/dashboard">
        <md-icon>dashboard</md-icon>
        <p>Hub</p>
      </sidebar-link>
      <sidebar-link to="/access-passes">
        <md-icon>assignment_turned_in</md-icon>
        <p>Access Passes</p>
      </sidebar-link>

      <li class="md-list-item">
        <a
          href="https://primepark.com.au/location/sydney-markets"
          target="_blank"
          class="md-list-item-router md-list-item-container nav-item bg-blue"
        >
          <div class="md-list-item-content md-ripple ">
            <md-icon>local_parking</md-icon>
            <p>Entry & Parking Passes</p>
          </div>
        </a>
      </li>

      <sidebar-link to="/business">
        <md-icon>business_center</md-icon>
        <p>Business Details</p>
      </sidebar-link>
      <!-- <sidebar-link to="/media">
        <md-icon>perm_media</md-icon>
        <p>Media Database</p>
      </sidebar-link>
      <sidebar-link to="/recipes">
        <md-icon>summarize</md-icon>
        <p>Recipes</p>
      </sidebar-link> -->
      <sidebar-link to="/billing">
        <md-icon>credit_card</md-icon>
        <p>Billing History</p>
      </sidebar-link>
      <!-- <sidebar-link to="/marketplace">
        <md-icon>shopping_bag</md-icon>
        <p>Marketplace</p>
      </sidebar-link>
      <sidebar-link to="/markettours">
        <md-icon>storefront</md-icon>
        <p>Market Tours</p>
      </sidebar-link> -->
      <sidebar-link to="/advertising">
        <md-icon>campaign</md-icon>
        <p>Advertising</p>
      </sidebar-link>
      <sidebar-link to="/enquiry">
        <md-icon>help</md-icon>
        <p>Enquiry</p>
      </sidebar-link>
      <sidebar-link to="/logout" class="logout">
        <md-icon>logout</md-icon>
        <p>Log Out</p>
      </sidebar-link>
    </side-bar>

    <div class="main-panel">
      <top-navbar></top-navbar>
      <banner position="header" />

      <dashboard-content> </dashboard-content>
      <survey />
      <content-footer
        v-if="!$route.meta.hideFooter"
        class="bg-secondary"
      ></content-footer>
    </div>
  </div>
</template>

<script>
import TopNavbar from "@/views/Layout/Components/TopNavbar.vue";
import ContentFooter from "@/views/Layout/Components/ContentFooter.vue";
import DashboardContent from "@/views/Layout/Components/Content.vue";
import MobileMenu from "@/views/Layout/Components/MobileMenu.vue";
import Survey from "@/views/WHSInformation/Survey.vue";
import Banner from "@/components/Banner.vue";

export default {
  components: {
    TopNavbar,
    DashboardContent,
    ContentFooter,
    MobileMenu,
    Survey,
    Banner
  },
  data() {
    return {
      sidebarBackground: "green",
      sidebarBackgroundImage: ""
    };
  }
};
</script>

<style>
.bg-blue {
  background-color: #2560a6;
}
</style>
